module.exports = __webpack_public_path__ + "img/4-Sum-Table.4b2ce0e5.png";